<template>
  <b-modal :id="id" :hide-header="true" footer-class="confirm-modal-footer" body-class="confirm-modal-body" size="md" centered>
    <template v-slot:default>
      <h5 class="text-center">{{ title }}</h5>
      <p class="text-center pt-2">{{ description }}</p>
    </template>
    <template v-slot:modal-footer>
      <button class="btn" @click="cancelModal($event)">{{ cancel }}</button>
      <button class="btn" @click="confirmModal($event)">{{ confirm }}</button>
    </template>
  </b-modal>
</template>

<script>
import common from "@/mixins/common";

export default {
  name: 'ConfirmationModal',
  mixins: [common],
  props: {
    id: String,
    title: {
      type: String,
      default() {
        return this.$t('confirmModal.title');
      },
    },
    description: {
      type: String,
      default() {
        return this.$t('confirmModal.description');
      },
    },
    cancel: {
      type: String,
      default() {
        return this.$t('confirmModal.cancel');
      },
    },
    confirm: {
      type: String,
      default() {
        return this.$t('confirmModal.confirm');
      },
    },
  },
  methods: {
    confirmModal(event) {
      this.closeModal(this.id);
      this.$emit('confirm', event);
    },
    cancelModal(event) {
      this.closeModal(this.id);
      this.$emit('cancel', event);
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">

</style>
